import auth from './auth'
import layout from './layout'
import app from './app'

export default {
    auth,
    layout,
    app
}